import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CountryManagementService } from '../../../service/country-management.service';
import { KeyValues5, LocalService, NumericConfig } from '../../../service/local.service';

@Component({
  selector: 'app-country-contact',
  templateUrl: './country-contact.component.html',
  styleUrls: ['./country-contact.component.scss']
})
export class CountryContactComponent {
  @Input() countryId; selectedItem: KeyValues5; @Input() phoneNumber: string = ''; @Input() phoneNumberNum: number = null; @Input() countryCode: string = '';
  @Output() onContactUpdated = new EventEmitter(); @Output() onEnterPressed = new EventEmitter(); @Input() isSetFromLogin = false;
  elementIds: any = {
    ph_num: 'ph_num'
  };
  numericConfig: NumericConfig = {} as NumericConfig;

  constructor(public localService: LocalService, private countryManagementService: CountryManagementService) { }

  ngOnChanges(): void {
    setTimeout(() => { //To avoid NG0100 error
      if (this.phoneNumber != '')
        this.phoneNumberNum = parseInt(this.phoneNumber);
      this.numericConfig.maxDigits = this.localService.getContactMaxDigitByCountryCode(this.localService.getLoginAsCountryCode() );
      this.onLoad();
    }, 0);
  }

  onLoad() {
    if (!this.localService.countryCodes) {
      this.countryManagementService.getCountryCodesToDisplay().subscribe(result => {
        this.localService.countryCodes = result;
        this.onCountryChanged();
      });
    } else {
      this.onCountryChanged();
    }
  }

  onCountryChanged() {
    if (this.phoneNumber != '') {
      this.phoneNumber = '';
    } else {
      this.phoneNumberNum = null;
    }
    if (!this.countryId) {
      let defacultCountry = this.countryCode != '' ? this.localService.countryCodes.find(x => x.v2 == this.countryCode) : this.localService.countryCodes.find(x => x.v2 == this.localService.selected.countryCode);
      this.countryId = defacultCountry ? defacultCountry.key : this.localService.getCurrentTimeZoneCountryId();
    }
    this.selectedItem = this.localService.countryCodes.find(x => x.key == this.countryId);
    this.onUpdate();
    this.localService.onFocusNextInput(this.elementIds.ph_num, 1);
  }

  onUpdate() {
    this.selectedItem.v5 = this.phoneNumberNum == null ? '' : this.phoneNumberNum.toString();
    this.selectedItem.isReadonly = this.selectedItem.v5.length == parseInt(this.selectedItem.v4);
    this.onContactUpdated.emit(this.selectedItem);
  }

  onEntered() {
    this.onEnterPressed.emit();
  }
}
